<form class="container-form" [formGroup]="pcForm">
    <div class="card py-3">
    <span class="title-card">กรอกข้อมูล เควส</span>
    <div class="row">
      <div class="col-sm-12">
        <label for="quest" class="col-form-label"
          >รายการเควส <span class="text-danger">*</span></label
        >
      </div>
      <div class="col-sm-12">
        <select
          class="form-select"
          id="quest"
          formControlName="quest"
          (change)="changeQuest($event)"
        >
          <option value="" disabled selected>เลือกรายการเควส</option>
          <option *ngFor="let quest of quests" [value]="quest.id">
            {{ quest.name }}
          </option>
          <!-- Add options here -->
        </select>
      </div>
    </div>
    <div
      *ngIf="f['questBatchCode'].value && f['quest'].value != ''"
      class="row"
    >
      <div class="col-sm-12">
        <label for="batchCode" class="col-form-label"
          >Batch Code<span class="text-danger">*</span></label
        >
      </div>
      <div class="col-sm-12">
        <input
          type="text"
          class="form-control"
          id="batchCode"
          formControlName="batchCode"
          placeholder="กรอก Batch Code"
        />
        <!-- <div *ngIf="f['batchCode'].touched && f['batchCode'].invalid" class="text-danger"> -->
        <!-- <small *ngIf="f['batchCode'].errors?.['required']">กรุณากรอก Batch Code</small> -->
        <!-- </div> -->
      </div>
    </div>
    <div
      *ngIf="f['questBatchCode'].value && f['quest'].value != ''"
      class="row"
    >
      <div class="col-sm-12">
        <label for="assistantPc" class="col-form-label"
          >อัปโหลดสลิป<span class="text-danger">*</span></label
        >
      </div>
      <div class="col-sm-12">
        <app-drop-zone-image formControlName="imageUrl" (image)="onImageSelected($event)"></app-drop-zone-image>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <label for="assistantPc" class="col-form-label"
          >Assistance PC<span class="text-danger">*</span></label
        >
      </div>
      <div class="col-sm-12">
        <input
          type="text"
          class="form-control"
          id="assistantPc"
          formControlName="assistantPc"
          placeholder="กรอก Assistance PC"
        />
        <!-- <div *ngIf="f['assistantPc'].touched && f['assistantPc'].invalid" class="text-danger"> -->
        <!-- <small *ngIf="f['assistantPc'].errors?.['required']">assistantPc is required</small> -->
        <!-- <small *ngIf="f['assistantPc'].errors?.['minlength']">assistantPc must be at least 3 characters long</small> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</form>